import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface TimelineState {
  timeline: string
  set: (value: string) => void
}

export const useTimelineStore = create<TimelineState>()(
  persist(
    (set) => ({
      timeline: "1W",
      set: (value: string) => set({ timeline: value }),
    }),
    {
      name: 'timeline-storage', // key in localStorage
    }
  )
)
